'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { LogOut } from 'lucide-react';
import { toast } from 'sonner';
import { logout } from '@/actions/mixed/auth';
import { useNpsStore } from '@/stores/npsStore';

export function Logout() {
  const handleLogout = async () => {
    try {
      await logout();

      useNpsStore.getState().reset();
      localStorage.removeItem('onboarding_check_completed');

      window.location.href = process.env.NEXT_PUBLIC_FE_URL_AUTH!;
    } catch {
      toast.error('Failed to logout, please try again later');
    }
  };

  return (
    <button
      onClick={handleLogout}
      className="group peer/menu-button text-sidebar-foreground active:bg-sidebar-accent active:text-sidebar-accent-foreground data-[active=true]:bg-sidebar-accent data-[active=true]:text-sidebar-accent-foreground data-[state=open]:hover:bg-sidebar-accent data-[state=open]:hover:text-sidebar-accent-foreground hover:bg-sidebar-accent hover:text-sidebar-accent-foreground flex h-10 w-full cursor-pointer items-center gap-2 overflow-hidden rounded-md p-2 text-left text-sm outline-hidden transition-[width,height,padding] group-has-data-[sidebar=menu-action]/menu-item:pr-8 group-data-[collapsible=icon]:size-10! group-data-[collapsible=icon]:p-2! focus-visible:ring-2 disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:opacity-50 [&>span:last-child]:truncate [&>svg]:size-[24px] [&>svg]:shrink-0 lg:[&>svg]:size-6"
      aria-label={'Logout'}
    >
      <LogOut />

      <span className="text-sidebar-foreground">{'Logout'}</span>
    </button>
  );
}
